// Events for the REC cache.
// TODO consider to place in an object...

const IndividualRefreshEvent = 'rec-cache-individual-refresh'
const IndividualDeleteEvent = 'rec-cache-individual-delete'
const CollectionSizeUpdateEvent = 'rec-cache-collection-size-update'
const SyncProgressEvent = 'rec-cache-sync-progress'
const CacheUpdateEvent = 'rec-cache-update'
const CacheDeleteEvent = 'rec-cache-delete'
const CacheSyncCompleteEvent = 'rec-cache-sync-complete'

// Dispatched by the client just before CacheSyncCompleteEvent.
// Carries an array of twin $dtId strings that were seen during sync but
// skipped by the client's ETag filter (unchanged since last sync).
// RecCache uses this to mark skipped twins as "still present" so the
// resync cleanup doesn't mistake them for deletions.
const SyncSkippedIdsEvent = 'rec-cache-sync-skipped-ids'
const CacheHydrationCompleteEvent = 'rec-cache-hydration-complete'

// Persistent state messages from client operations (e.g. transaction recovery results).
// Detail: { id, severity, title, detail, journalData }
const PersistentStateMessageEvent = 'rec-cache-persistent-state-message'

export {
  IndividualRefreshEvent,
  IndividualDeleteEvent,
  CollectionSizeUpdateEvent,
  SyncProgressEvent,
  SyncSkippedIdsEvent,
  CacheUpdateEvent,
  CacheDeleteEvent,
  CacheSyncCompleteEvent,
  CacheHydrationCompleteEvent,
  PersistentStateMessageEvent,
}
